import { cx } from "../components";
import logo from "../components/Logo.module.css";
import { useBranding } from "./context";

/**
 * Le sigle de la plateforme dans un en-tête : son logo s'il en a un, sinon son
 * sigle en lettres. Décoratif — le nom est toujours écrit à côté.
 *
 * La pastille est celle de `Logo` : quatre écrans en avaient chacun leur copie,
 * et la marque d'une entreprise ne ressemblait pas tout à fait à celle de la
 * plateforme.
 */
export function Sigle({ className }: { className?: string }) {
  const { logo_url, product_short } = useBranding();
  return (
    <span className={cx(logo_url === null ? logo.sigle : logo.logo, logo.md, className)} aria-hidden="true">
      {logo_url !== null ? (
        <img src={logo_url} alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
      ) : (
        product_short
      )}
    </span>
  );
}
